import {useQuery} from '@tanstack/react-query';
import {getFaqSubCategory} from '@/api/help/faq';

export const useGetFaqSubCategory = ({
  mainCategory,
}: {
  mainCategory: string;
}) => {
  return useQuery({
    queryKey: ['help', 'subCategory', mainCategory],
    queryFn: () => getFaqSubCategory({mainCategory}),
    select: (data) =>
      data.data.nodeList.map(({nodeId, nodeName}) => ({
        label: nodeName,
        value: nodeId,
      })),
  });
};
